import React from "react";
import Header from "../layouts/header";
import EducationCoursesIndex from "../components/educationCourses";

export default function EducationCourses() {

    return (
        <div>
            <Header />
            <EducationCoursesIndex />
        </div>
    )
};